import { render, staticRenderFns } from "./NavbarUserItem.vue?vue&type=template&id=e61f6efc"
import script from "./NavbarUserItem.vue?vue&type=script&lang=js"
export * from "./NavbarUserItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports